import React from 'react';

import {DropZone} from '@pb/kit-component-dropzone';

import {DropZoneView} from './drop-zone-view';

import {fileInputDropzone} from './file-input.module.styl';

type Props = {
    multiple: boolean,
    description: string,
    acceptedMimeTypes: string[],
    acceptedFormats: string[],
    onDrop: (accepted: Array<File>) => void,
    addedFile: File | null,
};

export const FileInput = ({multiple, onDrop, addedFile, acceptedFormats, description, acceptedMimeTypes}: Props) => {
    return (
        <DropZone accept={acceptedMimeTypes.join(',')} multiple={multiple} onDrop={onDrop} mix={fileInputDropzone}>
            <DropZoneView
                addedFile={addedFile}
                description={description}
                acceptedFormats={acceptedFormats}
            />
        </DropZone>
    );
};
